export const EXPECT_AI_ALLOWLIST = ["unexpected_rows_expectation"] as const
export type ExpectAiAllowedExpectation = (typeof EXPECT_AI_ALLOWLIST)[number]

export const isExpectAiAllowedExpectation = (
  expectationType: string,
): expectationType is ExpectAiAllowedExpectation => {
  return EXPECT_AI_ALLOWLIST.includes(expectationType as ExpectAiAllowedExpectation)
}

const POSTGRES_FLAVOR_DATA_SOURCES = ["NEON", "CITUS", "ALLOY", "AURORA"]

const SUPPORTED_DATA_SOURCE_TYPES = [
  "SNOWFLAKE",
  "POSTGRES",
  "REDSHIFT",
  "DATABRICKS_SQL",
  ...POSTGRES_FLAVOR_DATA_SOURCES,
]

export const isExpectAiSupportedDataSource = (datasourceType: string): boolean =>
  SUPPORTED_DATA_SOURCE_TYPES.includes(datasourceType)
